import { useStore } from "@store/index";
import { getSession, useSession } from "next-auth/react";
import { useEffect, useState } from "react";

// A wrapper around next-auth getSession
export async function getAuth() {
    const session = await getSession();
    const isAuthenticated = typeof session !== "undefined" && session !== null;
    const isAnonymous = session?.anonymousId && isAuthenticated;
    const hasSession = isAuthenticated || isAnonymous;
    return {
        session,
        isAuthenticated,
        isAnonymous: session?.anonymousId && isAuthenticated,
        hasSession,
    };
}

// A wrapper around next-auth useSession
export function useAuth() {
    const { data: session } = useSession();
    const isLoggedIn = useStore((state) => state.data.me.isLoggedIn);
    const customer = useStore((state) => state.data.me.customer);
    // HEAP is not returning session name, if we define this here can be used as the prev implementation
    const user = `${customer?.firstName} ${customer?.lastName}`;

    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isAnonymous, setIsAnonymous] = useState(false);
    const [hasSession, setHasSession] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setIsLoading(true);
        const nextIsAuthenticated =
            typeof session !== "undefined" && session !== null && !session?.anonymousId;
        const nextIsAnonymous =
            typeof session?.anonymousId !== "undefined" && session?.anonymousId !== null;
        setIsAuthenticated(isLoggedIn ?? nextIsAuthenticated);
        setIsAnonymous(nextIsAnonymous);
        setHasSession(nextIsAuthenticated || nextIsAnonymous);
        setIsLoading(false);
    }, [session]);

    return {
        session,
        user,
        isAuthenticated,
        isAnonymous,
        hasSession,
        isLoading,
    };
}
